import { render, staticRenderFns } from "./uploadMaterial.vue?vue&type=template&id=3984f03a&scoped=true"
import script from "./uploadMaterial.vue?vue&type=script&lang=js"
export * from "./uploadMaterial.vue?vue&type=script&lang=js"
import style0 from "./uploadMaterial.vue?vue&type=style&index=0&id=3984f03a&prod&scoped=true&lang=css"
import style1 from "./uploadMaterial.vue?vue&type=style&index=1&id=3984f03a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984f03a",
  null
  
)

export default component.exports